<template>
    <ActivityDetailsCard :activityType="activityType" :title="title" :entity="item.entity" class="work-history-details">
        <template #sub-header>
            <div class="cell">
                <h5>Company:</h5>
                {{ company.name }}
            </div>
            <div class="cell">
                <h5>Ticker:</h5>
                {{ company.symbol || 'N/A' }}
            </div>
            <div class="cell">
                <h5>Sector:</h5>
                {{ company.sector || 'N/A' }}
            </div>
            <div class="cell">
                <h5>Industry:</h5>
                {{ company.industry || 'N/A' }}
            </div>
        </template>
        <template #default>
            <ActivityStockPriceLine :item="item" />
            <ProfileSection title="Timeline">
                <KnobJobs :items="items" />
            </ProfileSection>
        </template>
    </ActivityDetailsCard>
</template>

<script>
import ActivityDetailsCard from './ActivityDetailsCard.vue'
import ActivityStockPriceLine from './ActivityStockPriceLine.vue'
import KnobJobs from '@/components/activity/ActivityKnobJobs.vue'
import ProfileSection from '@/components/shared/profile-section.vue'

export default {
    name: 'WorkHistoryDetails',
    components: {
        ActivityDetailsCard,
        ActivityStockPriceLine,
        KnobJobs,
        ProfileSection,
    },
    props: {
        item: {
            type: Object,
            required: true,
        },
    },
    computed: {
        activityType() {
            return this.item?.details?.type || ''
        },
        company() {
            return this.item?.details?.company || {}
        },
        description() {
            return this.item?.description || ''
        },
        items() {
            return this.item?.details?.items || []
        },
        title() {
            return this.item?.details?.title || ''
        },
    },
    methods: {},
}
</script>
<style>
.work-history-details {
    .knob-jobs tr:first-child td:last-child {
        font-weight: bold;
        font-size: 15px;
    }
}
</style>
